import { Icon } from '@iconify/react';
import { ReactNode } from 'react';
import TelegramIcon from 'assets/icons/ic-telegram.svg';
import { useTheme } from 'styled-components';

interface PluginMetadata {
  name: string;
  description: string;
  icon: ReactNode;
}

export const GetPluginMetaByID = (pluginID: number): PluginMetadata => {
  const theme = useTheme();
  const dataMap: Record<number, PluginMetadata> = {
    1: {
      name: 'Join Telegram app',
      description: 'Join Telegram app',
      icon: <img src={TelegramIcon} width={18} height={18} alt="Telegram" /> // wrap imported SVG
    },
    2: {
      name: 'Redirect',
      description: 'Redirect to a URL',
      icon: (
        <Icon
          icon="dashicons:external"
          color={theme.styleguideColors.contentSecondary}
          width="18"
          height="18"
          style={{ paddingBottom: '2px' }}
        />
      )
    },
    3: {
      name: 'External verification',
      description: 'Verification via external endpoint',
      icon: <Icon icon="dashicons:admin-generic" width="18" height="18" />
    },
    4: {
      name: 'Action based',
      description: 'Notify Make Traffic about user actions',
      icon: <Icon icon="dashicons:admin-users" width="18" height="18" />
    },
    5: {
      name: 'Quiz',
      description: 'User completes a quiz',
      icon: <Icon icon="mdi:quiz" width="18" height="18" />
    }
  };

  return dataMap[pluginID];
};
